import { useState, useEffect } from 'react';
import { Checkbox } from '../../checkbox'
import { State } from './state'

import { Container, RegionsContent } from './style';


export function Region({ region, setListStatesToSearch, listStatesToSearch }) {
    const [selectedRegion, setSelectedRegion] = useState(0)

    const [statesListChecked, setStatesListChecked] = useState([])
    

    function handleSetAllStatesChecked(){
        if(selectedRegion === 0){
            setStatesListChecked(region.states.map(state =>{
                return state.idState
             }))
             setListStatesToSearch(listStatesToSearch.concat(region.states.map(state =>{ return state.idState })))
        }
        else{
            setListStatesToSearch(listStatesToSearch.filter(function (elem) { 
                return statesListChecked.indexOf(elem) === -1 
            }))
            setStatesListChecked([])
        }
    }


    useEffect(() =>{
        if(statesListChecked.length === region.states.length){
          setSelectedRegion(1)
        }  
        else if(statesListChecked.length === 0){
          setSelectedRegion(0)
        }
        else if(statesListChecked.length > 0 && statesListChecked.length < region.states.length){
          setSelectedRegion(2)
        }
    }, [statesListChecked, region])


    return(
        <Container>

            <RegionsContent>
                <Checkbox 
                    selected={selectedRegion} 
                    handleChangeStatus={handleSetAllStatesChecked}
                    size={'1.5rem'}
                />
                <p>{region.region}</p>
            </RegionsContent>
           

            {
                region.states.map(state =>(
                    <State 
                        key={state.idState}
                        state={state}
                        setStatesListChecked={setStatesListChecked}
                        statesListChecked={statesListChecked}
                        setListStatesToSearch={setListStatesToSearch}
                        listStatesToSearch={listStatesToSearch}
                    />
                ))
            }   


        </Container>
    )
}
